class Carousel {
  constructor() {
    this.sel = {
      carouselAwards: '.carouselAwards__sliders',
      carouselEvents: '.carouselEvents__sliders',
      carouselSignpost: '.carouselSignpost__sliders',
      carouselVideoImage: '.carouselVideoImage__sliders',
      carouselImageGallery: '.imageGallery__sliders',
      carouselOverlayTitle: '.overlay__title',
      carouselOverlay: '.overlay__wrapper',
      quoteSlider: '.quote__slider',
      carouselSignpostPanel: '.carouselSignpost',
      carouselVideoImagePanel: '.carouselVideoImage',
      imageGalleryPanel: '.imageGallery',
    };
    this.init = this.init.bind(this);
    this.bindEvents = this.bindEvents.bind(this);
    this.setCarousel = this.setCarousel.bind(this);
    this.toggleOverlay = this.toggleOverlay.bind(this);
    this.updateButtonPosition = this.updateButtonPosition.bind(this);
  }

  bindEvents() {
    this.setCarousel();
    this.toggleOverlay();
    this.updateButtonPosition();
    $(window).on('resize', () => {
      this.setCarousel();
      this.updateButtonPosition();
    });
  }

  setCarousel() {
    if ($(this.sel.carouselEvents).length) {
      const autoplay = $(this.sel.carouselEvents).attr('data-autoplay') !== undefined;
      const autoplaySpeed = autoplay ? parseInt($(this.sel.carouselEvents).attr('data-autoplay'), 10) : 0;
      $(this.sel.carouselEvents).not('.slick-initialized').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        variableWidth: true,
        autoplay,
        autoplaySpeed,
      });
    }
    if ($(this.sel.carouselAwards).length) {
      const autoplay = $(this.sel.carouselAwards).attr('data-autoplay') !== undefined;
      const autoplaySpeed = autoplay ? parseInt($(this.sel.carouselAwards).attr('data-autoplay'), 10) : 0;
      $(this.sel.carouselAwards).not('.slick-initialized').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        variableWidth: true,
        autoplay,
        autoplaySpeed,
        rows: 0,
      });
    }
    if ($(this.sel.carouselSignpost).length) {
      const autoplay = $(this.sel.carouselSignpost).attr('data-autoplay') !== undefined;
      const autoplaySpeed = autoplay ? parseInt($(this.sel.carouselSignpost).attr('data-autoplay'), 10) : 0;
      $(this.sel.carouselSignpost)
        .not('.slick-initialized')
        .slick({
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          variableWidth: true,
          autoplay,
          autoplaySpeed,
          responsive: [
            {
              breakpoint: 576,
              settings: 'unslick',
            },
          ],
        });
    }

    if ($(this.sel.carouselVideoImage).length) {
      const autoplay = $(this.sel.carouselVideoImage).attr('data-autoplay') !== undefined;
      const autoplaySpeed = autoplay ? parseInt($(this.sel.carouselVideoImage).attr('data-autoplay'), 10) : 0;
      $(this.sel.carouselVideoImage)
        .not('.slick-initialized')
        .slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 1,
          variableWidth: true,
          autoplay: false,
          autoplaySpeed,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                dots: true,
              },
            },
          ],
        });
    }

    if ($(this.sel.carouselImageGallery).length) {
      const autoplay = $(this.sel.carouselImageGallery).attr('data-autoplay') !== undefined;
      const autoplaySpeed = autoplay ? parseInt($(this.sel.carouselImageGallery).attr('data-autoplay'), 10) : 0;
      $(this.sel.carouselImageGallery).not('.slick-initialized').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        variableWidth: true,
        autoplay,
        autoplaySpeed,
      });
    }

    if ($(this.sel.quoteSlider).length) {
      const autoplay = $(this.sel.quoteSlider).attr('data-autoplay') !== undefined;
      const autoplaySpeed = autoplay ? parseInt($(this.sel.quoteSlider).attr('data-autoplay'), 10) : 0;
      $(this.sel.quoteSlider).not('.slick-initialized').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        autoplay,
        autoplaySpeed,
      });
    }
  }

  toggleOverlay() {
    $(document).on('click', this.sel.carouselOverlayTitle, (e) => {
      if ($(e.target).parent().hasClass('show')) {
        $(e.target).parent().removeClass('show');
      } else {
        $(this.sel.carouselOverlay).removeClass('show');
        $(e.target).parent().addClass('show');
      }
    });
  }

  updateButtonPosition() {
    if ($(this.sel.carouselSignpostPanel).length) {
      const height = $(this.sel.carouselSignpostPanel).find('.introPanelBlock').height() + 1;
      $(this.sel.carouselSignpostPanel).find('.slick-arrow').css('top', height);
    }
    if ($(this.sel.imageGalleryPanel).length) {
      const height = $(this.sel.imageGalleryPanel).find('.introPanelBlock').height() + 1;
      $(this.sel.imageGalleryPanel).find('.slick-arrow').css('top', height);
    }
    if ($(this.sel.carouselVideoImagePanel).length) {
      const height = $(this.sel.carouselVideoImagePanel).find('.introPanelBlock').height() + 1;
      $(this.sel.carouselVideoImagePanel).find('.slick-arrow').css('top', height);
    }
  }

  init() {
    this.bindEvents();
  }
}

export default new Carousel();
